import { DEFAULT_LOCALE, LOCALE_PATH_PAT, WWW_LOCALES } from 'src/constants/locales';

type LocationParts = {
  pathname: string;
  search?: string;
  hash?: string;
};

/**
 * На www доступны только локали из WWW_LOCALES, на остальные нужен редирект
 * на DEFAULT_LOCALE. В whitelabel-сборках локали произвольные, ограничений нет.
 *
 * Возвращает URL для редиректа или null, если редирект не нужен.
 */
export const getDefaultLocaleRedirectUrl = ({
  pathname,
  search = '',
  hash = '',
}: LocationParts): string | null => {
  if (__WHITE_LABEL__) {
    return null;
  }

  const localeMatch = pathname.match(LOCALE_PATH_PAT);

  // Префикса локали нет: /, /_spa/..., /set-locale/en-ae/, /robots.txt
  if (!localeMatch) {
    return null;
  }

  const [localePrefix, locale] = localeMatch;

  if (WWW_LOCALES.includes(locale)) {
    return null;
  }

  const restPath = pathname.slice(localePrefix.length) || '/';

  return `/${DEFAULT_LOCALE}${restPath}${search}${hash}`;
};
